/**
 * DOM helper functions for input reveal/unreveal visual changes.
 *
 * These are separated from the Zustand store to keep state management
 * pure and testable. Call these from the UI layer (action handlers)
 * after updating store state.
 */

/**
 * Apply DOM changes when an input is marked as revealed (answer shown).
 * Disables the input and hides it from view.
 */
export function applyInputRevealedDOM(actionId: string): void {
  const selector = `input[data-action-id="${actionId}"]`;
  const input = document.querySelector(selector) as HTMLInputElement | null;

  if (!input) return;

  // Disable interaction
  input.disabled = true;
  input.style.pointerEvents = "none";

  // Hide the LaTeX display overlay
  const latexDisplay = input.parentElement?.querySelector(
    "[data-latex-display]"
  ) as HTMLElement | null;
  if (latexDisplay) {
    latexDisplay.style.display = "none";
  }

  // Hide the entire input block element
  const inputBlock = input.closest(
    '.sl-block[data-element-type="input"]'
  ) as HTMLElement | null;
  if (inputBlock) {
    inputBlock.style.display = "none";
  }
}

/**
 * Apply DOM changes when an input is unmarked as revealed (navigating backward).
 * Re-enables the input and restores its visibility.
 */
export function applyInputUnrevealedDOM(actionId: string): void {
  const selector = `input[data-action-id="${actionId}"]`;
  const input = document.querySelector(selector) as HTMLInputElement | null;

  if (!input) return;

  // Re-enable interaction
  input.disabled = false;
  input.style.pointerEvents = "auto";

  // Show the entire input block element first (so children are accessible)
  const inputBlock = input.closest(
    '.sl-block[data-element-type="input"]'
  ) as HTMLElement | null;
  if (inputBlock) {
    inputBlock.style.display = "";

    // Restore grey box styling (reset any incorrect answer styling)
    const greyBox = inputBlock.querySelector(
      'div > div[style*="background-color"]'
    ) as HTMLElement | null;
    if (greyBox) {
      greyBox.style.backgroundColor = "#F1F1F1";
      greyBox.style.border = "2px solid #e4e4e4";
    }
  }

  // Show the LaTeX display overlay again
  const latexDisplay = input.parentElement?.querySelector(
    "[data-latex-display]"
  ) as HTMLElement | null;
  if (latexDisplay) {
    latexDisplay.style.display = "";
  }
}
